<template>
    <div v-loading="loading" class="performance-adjustment-audit-info">
        <div class="audit-operate-part" v-if="!isSupplier && auditInfo.isApproval === '1'">
            <div>
                <el-button class="bigData-btn-submit" type="primary" :loading="submitLoading" @click="submit">
                    提交
                </el-button>
            </div>
            <el-form ref="form" :model="form" :rules="rules" size="mini">
                <el-form-item prop="auditStatus">
                    <el-radio-group v-model="form.auditStatus">
                        <el-radio :label="AUDIT_STATUS.ADOPT">通过</el-radio>
                        <el-radio :label="AUDIT_STATUS.REJECT">驳回</el-radio>
                    </el-radio-group>
                </el-form-item>
            </el-form>
        </div>
        <div
            class="audit-operate-part"
            v-if="isSupplier && [AUDIT_STATUS.DRAFT, AUDIT_STATUS.PENDING].includes(auditInfo.auditStatus)">
            <div>
                <el-button class="bigData-btn-submit" type="primary" :loading="submitLoading" @click="submit">
                    提交
                </el-button>
            </div>
            <el-form ref="form" :model="form" :rules="rules" size="mini">
                <el-form-item prop="auditStatus">
                    <el-radio-group v-model="form.auditStatus">
                        <el-radio :label="AUDIT_STATUS.WITHDRAW">撤回</el-radio>
                        <el-radio :label="AUDIT_STATUS.ABANDONMENT">废弃</el-radio>
                    </el-radio-group>
                </el-form-item>
            </el-form>
        </div>
        <div class="audit-detail-title">审批详情</div>
        <div class="content">
            <el-row>
                <el-col class="has-bg" :span="5">提交人</el-col>
                <el-col :span="7">{{ auditInfo.createUserName }}</el-col>
                <el-col class="has-bg" :span="5">提交时间</el-col>
                <el-col :span="7">{{ auditInfo.createTime }}</el-col>
            </el-row>
            <el-row>
                <el-col class="has-bg" :span="5">审批状态</el-col>
                <el-col :span="7">{{ auditInfo.auditStatusText }}</el-col>
                <el-col class="has-bg" :span="5">mip流程编码</el-col>
                <el-col :span="7">{{ auditInfo.auditMipId }}</el-col>
            </el-row>
            <el-row>
                <el-col class="has-bg" :span="5">审批人</el-col>
                <el-col :span="19">{{ auditInfo.approvalUser }}</el-col>
            </el-row>
        </div>
        <ScoreForm ref="sfRef" :operateType="'audit'" :isPerformanceAdjustment="true" />
    </div>
</template>

<script>
import ScoreForm from '../../warehouseResourceManagement/performanceAssessDetail/ScoreForm.vue'
import { mapState } from 'vuex'
import { dictWithUrl } from '@/components/lots/api'
import { detailPerformance } from '../../../api/warehouseResourceManagement/performanceAssessDetail.js'
import { getMipAuditDetail, approvalMipAudit } from '../../../api/warehouseResourceManagement/performanceAdjustment.js'
import { AUDIT_STATUS } from '../../../constant/constant.js'

const INIT_INFO = {
    createUserName: '',
    createTime: '',
    auditStatus: '',
    auditStatusText: '',
    auditMipId: '',
    approvalUser: '',
    isApproval: '',
}

export default {
    components: { ScoreForm },
    data() {
        return {
            loading: false,
            submitLoading: false,
            dict: {},
            auditInfo: { ...INIT_INFO },
            AUDIT_STATUS,
            form: {
                auditStatus: '',
            },
            supplierLspMipAuditId: '',
            rules: {
                auditStatus: [{ required: true, message: '请选择审批状态', trigger: ['blur', 'change'] }],
            },
        }
    },
    computed: {
        ...mapState(['supplier']),
        isSupplier() {
            return !!this.supplier
        },
    },
    methods: {
        close() {
            this.form.auditStatus = ''
            this.supplierLspMipAuditId = ''
            this.$refs.form && this.$refs.form.clearValidate()
            this.auditInfo = { ...INIT_INFO }
            this.$refs.sfRef.clear()
        },
        submit() {
            this.$refs.form
                .validate()
                .then(valid => {
                    if (valid) {
                        this.submitLoading = true
                        approvalMipAudit(this.getParams())
                            .then(res => {
                                if (res && +res.code === 0) {
                                    this.$message.success('提交审批成功!')
                                    this.$emit('success')
                                }
                            })
                            .finally(() => {
                                this.submitLoading = false
                            })
                    }
                })
                .catch(err => {})
        },
        getParams() {
            const params = {
                id: this.supplierLspMipAuditId,
                auditStatus: this.form.auditStatus,
            }
            return params
        },
        load() {
            this.loading = true
            getMipAuditDetail({
                id: this.$route.query.supplierLspMipAuditId,
                auditMipId: this.$route.query.supplierLspMipAuditId ? '' : this.$route.query.processId,
            })
                .then(res => {
                    if (res && +res.code === 0) {
                        this.auditInfo.createUserName = res.data.createUserName
                        this.auditInfo.createTime = res.data.createTime
                        this.auditInfo.auditStatus = res.data.auditStatus
                        this.auditInfo.auditStatusText = this.dict.SRM_AUDIT_STATUS[res.data.auditStatus]
                        this.auditInfo.auditMipId = res.data.auditMipId
                        this.auditInfo.approvalUser = res.data.approvalUser
                        this.auditInfo.isApproval = res.data.isApproval
                    }
                })
                .finally(() => {
                    this.loading = false
                })
            detailPerformance(this.$route.query.id)
                .then(res => {
                    if (res && +res.code === 0) {
                        // 满足从MIP跳转过来时，从这个接口拿到传参
                        this.supplierLspMipAuditId = res.data.supplierLspMipAuditId
                        this.$refs.sfRef.setData(res.data)
                    }
                })
                .finally(() => {
                    this.loading = false
                })
        },
    },
    mounted() {
        dictWithUrl('SRM_AUDIT_STATUS').then(res => {
            if (res && +res.code === 0) {
                this.dict = res.data
                this.load()
            }
        })
    },
}
</script>

<style lang="less" scoped>
.performance-adjustment-audit-info {
    .audit-operate-part .el-form-item--mini.el-form-item {
        margin-bottom: 12px;
    }

    .audit-detail-title {
        line-height: 28px;
    }

    .content {
        margin-bottom: 10px;
        text-align: center;
        border-top: 1px solid #ddd;
        border-left: 1px solid #ddd;

        .el-row {
            display: flex;
            width: 100%;
        }

        .has-bg {
            background: #f5f7fa;
        }

        .el-col {
            float: none;
            padding: 5px;
            border-right: 1px solid #ddd;
            border-bottom: 1px solid #ddd;
        }
    }
}
</style>
